<template>
  <div :class="classes.component" @click="showSlider">
    <base-image :image="image" :lazy="true" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BaseImage from '@/components/base-image.vue'

export default {
  components: { BaseImage },
  props: {
    image: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(['bioVisible']),
    classes() {
      return {
        component: [
          this.$style.component,
          this.bioVisible ? this.$style['bio-visible'] : ''
        ]
      }
    }
  },
  methods: {
    showSlider() {
      this.$store.commit('bioVisibility', {
        bioVisible: false
      })
    },
    // Set current item in store to use it in artist-header
    setCurrentItem() {
      this.$store.commit('setCurrentItem', {
        currentItem: this.image
      })
    },
    unsetCurrentItem() {
      this.$store.commit('setCurrentItem', {
        currentItem: {}
      })
    }
  },
  created() {
    this.setCurrentItem()
  },
  activated() {
    this.setCurrentItem()
  },
  deactivated() {
    this.unsetCurrentItem()
  }
}
</script>

<style lang="scss" module>
.component {
  width: 100%;
  height: 100%;

  &.bio-visible {
    cursor: pointer;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
